module.exports = __webpack_public_path__ + "static/media/Digital-Design@2x.69c1383f.png";